import openUrl from 'helpers/openUrl';
import { getLegacyOneTrustGroups } from 'shared-utils/osanoConsentBridge';

const getGAClientIdFromCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)_ga=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : '';
};

const getLandingUrlFromCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)landing_url=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : '';
};

const appendQueryParams = (url, params) => {
  const [baseUrl, hash] = url.split('#');
  const [path, existingQuery = ''] = baseUrl.split('?');
  const searchParams = new URLSearchParams(existingQuery);

  Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null)
    .forEach(([key, value]) => {
      searchParams.set(key, value);
    });

  const queryString = searchParams.toString();

  if (!queryString) return url;

  return `${path}?${queryString}${hash ? `#${hash}` : ''}`;
};

const mapper = {
  0: 'U', // Undetermined
  1: 'G', // Granted
  2: 'D', // Denied
  3: 'G', // Implicit Granted -> Granted
  4: 'D', // Implicit Denied -> Denied
};

export const getConsentData = (windowObj) => {
  try {
    if (windowObj.GDMGetConsent) {
      return windowObj.GDMGetConsent();
    }
    if (windowObj.google_tag_data?.ics) {
      return [
        'ad_storage',
        'analytics_storage',
        'functionality_storage',
        'personalization_storage',
        'security_storage',
        'ad_user_data',
        'ad_personalization',
      ].reduce((acc, key) => {
        return {
          ...acc,
          [key]:
            mapper[
              windowObj.google_tag_data.ics.getConsentState(key, {
                /**
                 * getConsentState method expects this parameter on a edge case scenario that we don't know yet how to reproduce
                 * https://app.datadoghq.com/rum/error-tracking/issue/ac152b54-4498-11ef-86ec-da7ad0900002?refresh_mode=sliding&from_ts=1721056443887&to_ts=1721661243886&live=true
                 */
                containerScopedDefaults: {},
              })
            ] || 'U',
        };
      }, {});
    }
  } catch {
    return null;
  }
  return null;
};

export const getConsentModeData = (windowObj) => {
  return {
    LaunchDarkly: null,
    OneTrust: getLegacyOneTrustGroups(windowObj),
    Google: getConsentData(windowObj),
  };
};

const performClickout = (url, transactionId, listingPosition) => {
  const up = getConsentModeData(window);

  const positionParam = url.includes('/z/')
    ? '&listing_position=' + listingPosition || 0
    : '';

  const newUrl =
    url +
    '&transaction_id=' +
    transactionId +
    '&up=' +
    window.btoa(JSON.stringify(up)) +
    positionParam;

  openUrl(newUrl);
};

const performBxClickout = (url, transactionId) => {
  const up = getConsentModeData(window);
  const gaClientId = getGAClientIdFromCookie();
  const sessionStartPage = getLandingUrlFromCookie();

  const newUrl = appendQueryParams(url, {
    sessionStartPage: btoa(sessionStartPage),
    transactionId,
    privacy: window.btoa(JSON.stringify(up)),
    gaClientId: btoa(gaClientId),
  });

  openUrl(newUrl);
};

export { performClickout, performBxClickout };
